import { Stack } from '@mui/material';
import React from 'react';
import FromDatePicker from './Components/FromDatePicker';
import ToDatePicker from './Components/ToDatePicker';
import useKeepSelectedDateRange from 'Global/Hooks/useKeepSelectedDateRange';
import i18next from 'i18next';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import { useContext } from 'react';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
const DateRangePicker = ({
  ExcludeOneMonth = false,
  GetDateRange,
  onChange,
  disabled,
  errors,
  name,
  initialValue = false,
  KeepSelectedDate,
  ExcludeTenDay = false,
  isSmall = true,
  disableFromDate = false,
  disableMt = false,
  lockToday = false,
  LockToGreaterThanFrom=false
}) => {
  const [forceRender, setForceRender] =
    React.useState(false);
  const [Range, SelectRange] = React.useState({
    FromDate: '',
    ToDate: '',
  });
  React.useEffect(() => {
    if (GetDateRange) {
      GetDateRange((prev) => ({
        ...prev,
        ...Range,
      }));
    }
    if (onChange) {
      onChange(Range);
    }
  }, [Range]);
  KeepSelectedDate &&
    useKeepSelectedDateRange(
      SelectRange,
      Range,
      setForceRender
    );

  const languageArray =
    useContext(GlobalContext)?.LanguageArray;

  console.log("===>",Range)

  return (
    <React.Fragment>
      {forceRender ? <></> : <></>}
      <Stack
        sx={{ mt: disableMt ? 0 : '.5em' }}
        direction={
          i18next.language === 'en' ? 'row-reverse' : 'row'
        }
        spacing={2}
        alignItems="center"
        width="100%"
      >
        <Stack alignItems="center" width="100%">
          <sub style={{ marginBottom: '-1em' }}>
            {FindLangKey(
              'general-public-to',
              languageArray
            )}
          </sub>
          <ToDatePicker
            ExcludeOneMonth={false}
            GetJalaliValue={SelectRange}
            disabled={disabled}
            errors={errors}
            name={name}
            initialValue={
              KeepSelectedDate
                ? Range.ToDate
                : initialValue.ToDate
            }
            FromDate={Range.FromDate}
            LockToGreaterThanFrom={LockToGreaterThanFrom}
          />
        </Stack>
        <Stack alignItems="center" width="100%">
          <sub style={{ marginBottom: '-1em' }}>
            {FindLangKey(
              'general-public-from',
              languageArray
            )}
          </sub>
          <FromDatePicker
            ExcludeOneMonth={ExcludeOneMonth ?? true}
            GetJalaliValue={SelectRange}
            disabled={disabled}
            errors={errors}
            name={name}
            initialValue={
              KeepSelectedDate
                ? Range.FromDate
                : initialValue.FromDate
            }
            ExcludeTenDay={ExcludeTenDay}
            disableFromDate={disableFromDate}
            LockToday={lockToday}
          />
        </Stack>
      </Stack>
    </React.Fragment>
  );
};
export default DateRangePicker;
